import { Emitter, type Event } from '@patsnap/tahiti-core';

export type ChatInputRequiredSource =
    | 'waiting'
    | 'tool_result'
    | 'instruction_form'
    | 'template_section_form';

export interface ChatInputRequiredEvent {
    source: ChatInputRequiredSource;
    timestamp: string;
    conversationId?: string;
    toolCallId?: string;
    toolName?: string;
    turnId?: string;
    status?: string;
}

export interface ChatEventSource {
    readonly onInputRequired: Event<ChatInputRequiredEvent>;
}

export interface ChatEventPublisher {
    /** 发布当前对话需要用户输入的事实。 */
    publishInputRequired(event: ChatInputRequiredEvent): void;
}

/** 创建可隔离测试的聊天领域事件服务。 */
export function createChatEvents(): ChatEventSource & ChatEventPublisher {
    const inputRequiredEmitter = new Emitter<ChatInputRequiredEvent>({
        onListenerError: error => console.error('[ChatEvents] listener failed:', error),
    });
    return {
        onInputRequired: inputRequiredEmitter.event,
        publishInputRequired: event => inputRequiredEmitter.fire(event),
    };
}

/** 应用级聊天领域事件服务。 */
export const chatEvents = createChatEvents();
